module.exports = __webpack_public_path__ + "img/calendar-add.3bbc0af2.svg";